import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ProcessSection from '../../components/feature/ProcessSection';
import PhilosophySection from '../../components/feature/PhilosophySection';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';
import ContactSection from '../../components/feature/ContactSection';
import ServicesSection from '../../components/feature/ServicesSection';
import MidPageCTA from '../../components/feature/MidPageCTA';
import ServicesDetailSection from './components/ServicesDetailSection';

const SERVICES_FAQS = [
  {
    q: 'What interior design services does Lisa Merkle Design offer?',
    a: 'Lisa Merkle Design offers 24 luxury services: full house design, bedroom, kitchen, bathroom, living room, dining room, and home office design, plus renovation consultation, lighting selection, flooring, color consultation, art procurement, furniture selection and customization, space planning, commercial design, and more.',
  },
  {
    q: 'Do you offer renovation consultation services in Beverly Hills?',
    a: 'Yes — renovation consultation is one of our most-requested services in Beverly Hills and Los Angeles. We guide homeowners through planning, helping avoid costly mistakes and ensuring every design decision protects and enhances the long-term value of your property and investment.',
  },
  {
    q: 'Can you help with just one room or only full home design?',
    a: 'We work on projects of all scales — from a single bedroom or kitchen refresh to comprehensive full-home transformations. Our discovery consultation determines the right scope, timeline, and investment level for your specific project goals, lifestyle, and budget priorities.',
  },
  {
    q: 'Do you work on commercial spaces as well as residential?',
    a: 'Yes. Lisa Merkle Design provides commercial space design and office design services alongside our residential work. We create sophisticated professional environments that reflect your brand, impress clients, and elevate the experience of everyone who enters your space.',
  },
  {
    q: 'How do I get started with your interior design services?',
    a: 'Contact us by phone at (323) 745-2205 or submit the consultation form. We will schedule an initial discovery conversation to understand your vision, project scope, timeline, and investment goals before proposing next steps for your project.',
  },
];

export default function ServicesPage() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection
          badge="Interior Design Services"
          title="Expert Design &"
          titleItalic="Home Remodeling Services"
          subtitle="Beverly Hills · Los Angeles · California · Nationwide"
          description="Comprehensive luxury interior design services — from single rooms to full home transformations — delivered with precision and an uncompromising standard of craft."
          bgImage="https://lisamerkledesign.com/wp-content/uploads/2022/12/314729600_962445298048832_6610108580665789119_n.jpg"
          ctaText="Request a Service Consultation"
          ctaLink="/location#contact"
          secondaryCtaText="Call (323) 745-2205"
          secondaryCtaLink="tel:+13237452205"
        />
        <TrustBar />
        <ServicesDetailSection />
        <ServicesSection showAll limit={24} />
        <MidPageCTA
          heading="Every Service, Delivered at the Highest Level."
          subtext="Discuss your project with our Beverly Hills design team."
          ctaText="Request a Project Review"
          bgColor="charcoal"
        />
        <AIAnswerBlock
          eyebrow="About Our Services"
          heading="Interior Design Services Designed Around Your Vision"
          what="24 distinct luxury interior design services — from full home design and kitchen remodeling to lighting selection, art procurement, furniture customization, and renovation consultation, all delivered with editorial-level craft."
          who="Designed for discerning homeowners, property investors, developers, and design-conscious individuals in Beverly Hills, Los Angeles, and nationwide who value excellence and long-term investment protection."
          services="Full House Design · Renovation Consultation · Kitchen & Bathroom Design · Bedroom & Living Spaces · Lighting & Flooring · Art Procurement · Furniture Customization · Space Planning · Office & Commercial Design"
          benefits="UCLA-trained expertise, celebrity firm experience, full-service project leadership, premium vendor network, meticulous installation coordination, and design decisions that strengthen your property's long-term value."
          why="Formal UCLA training plus years at LA's top celebrity design firms. Published in Elle Décor and Architectural Digest. Personal project leadership from concept through final installation by Lisa Merkle herself."
          highlights={['Full House Design', 'Renovation Consultation', 'Kitchen & Bathroom', 'Lighting & Flooring', 'Art Procurement', 'Furniture Customization']}
        />
        <ProcessSection />
        <PhilosophySection />
        <ServiceAreasSection />
        <TestimonialsSection />
        <MidPageCTA
          heading="Start Your Design Journey Today."
          subtext="Our Beverly Hills studio is ready to bring your vision to life."
          ctaText="Schedule a Consultation"
          bgColor="warm"
        />
        <FAQSection faqs={SERVICES_FAQS} eyebrow="Service Questions" heading="Your Service Questions, Answered" />
        <FinalCTA
          title="Ready to Start Your Design Project?"
          subtitle="Contact us today to discuss your vision and schedule a private consultation."
          ctaText="Request a Project Review"
          bgImage="https://lisamerkledesign.com/wp-content/uploads/2022/12/185378651_3974479969308369_7407879718005515588_n.jpg"
        />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
